import React, { useRef, useState, useEffect } from "react";
import iris from "../img/oeil/iris.png";
import oeil from "../img/oeil/oeil.gif";
import "./Oeil.css";

const MAX_RADIUS = 10; // écart max de l’iris en pixels
const EASING = 0.2;    // adoucissement

const Oeil: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const targetPos = useRef({ x: 50, y: 50 }); // vers où l’iris doit aller (%)
  const [irisPos, setIrisPos] = useState({ x: 50, y: 50 }); // position affichée

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!containerRef.current) return;

      const rect = containerRef.current.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const dx = e.clientX - centerX;
      const dy = e.clientY - centerY;

      const distance = Math.sqrt(dx * dx + dy * dy);
      const angle = Math.atan2(dy, dx);

      // On écarte de plus en plus l’iris quand la souris est loin, jusqu’au MAX_RADIUS
    //   const offset =   Math.min(distance, MAX_RADIUS);
      const offset = Math.min(MAX_RADIUS*(distance/window.innerWidth),MAX_RADIUS*(distance/window.innerHeight))
      const offsetX = Math.cos(angle) * offset;
      const offsetY = Math.sin(angle) * offset;

      // Coordonnées de l’iris dans le conteneur
      const irisX = rect.width / 2 + offsetX;
      const irisY = rect.height / 2 + offsetY;

      const percentX = (irisX / rect.width) * 100;
      const percentY = (irisY / rect.height) * 100;

      targetPos.current = { x: percentX, y: percentY };
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    let frameId: number;

    const animate = () => {
      setIrisPos((current) => {
        const dx = targetPos.current.x - current.x;
        const dy = targetPos.current.y - current.y;

        const newX = current.x + dx * EASING;
        const newY = current.y + dy * EASING;

        return { x: newX, y: newY };
      });

      frameId = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(frameId);
  }, []);

  return (
    <div className="oeil-container" ref={containerRef}>
      <img
        src={iris}
        alt="iris"
        className="iris-image"
        style={{
          left: `${irisPos.x}%`,
          top: `${irisPos.y}%`,
        }}
      />
      <img src={oeil} alt="oeil" className="oeil-image" />
    </div>
  );
};

export default Oeil;
